import {
  RECEIVE_EXERCISES,
  SET_ACTIVE_EXERCISE,
  UPDATE_EXERCISE_INDEX
} from '../mutation-types'

// initial state
const state = {
  all: [],
  active: {}
}

// mutations
const mutations = {
  [RECEIVE_EXERCISES] (state, exercises) {
    exercises.forEach(function (exercise, index) {
      exercises[index].order = index
    })
    state.all = exercises
  },
  [SET_ACTIVE_EXERCISE] (state, id) {
    state.active = state.all.find(exercise => exercise.id === parseInt(id))
  },
  [UPDATE_EXERCISE_INDEX] (state, oldIndex, newIndex) {
    state.all.splice(newIndex, 0, state.all.splice(oldIndex, 1)[0])
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/exercises/store.js